module.exports = __webpack_public_path__ + "images/courses-banner-mobile.jpg";